import { ChevronTripleUpIcon } from './ChevronTripleUpIcon';

/**
 * author: Google
 * id C04D4C82-E95C-45E1-8582-89A24536026F
 * name chevron-triple-up
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-triple-up.svg
 * tags
 */
export const RankIcon = ChevronTripleUpIcon;
export default RankIcon